import * as React from 'react';
export const mindbodySvg = React.forwardRef(function mindbodySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2D2D2D',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      null,
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.966 22.38c-1.56.67-3.096-.25-3.755-1.743-.332-.752-1.188-3.194-1.993-5.37-.232-.628-1.159-.46-1.159.21 0 2.086-.005 4.25-.019 4.436-.026.377-.075 2.29-2.249 2.65-2.17.359-2.697-1.162-2.932-1.677-.268-.589-1.243-3.19-2.176-5.616-.244-.639-1.253-.454-1.187.227.462 6.724-1.906 7.565-3.235 7.035-1.552-.619-1.038-2.43-.304-3.75.177-.32 1.393-2.297 1.882-5.617.11-.737.422-3.916 3.439-4.324 3.643-.494 4.664 3.262 4.855 3.829.257.772 1.218.64 1.218-.171 0 0-.029-1.416.035-2.02.122-1.169.97-2.69 2.658-2.94 1.688-.248 2.814.698 3.437 2.114.173.393.928 2.119 1.59 3.985.736 2.08 1.37 4.318 1.476 4.769.204.857.551 3.058-1.578 3.978l-.003-.006Z',
        fill: '#AAFFD8',
      }),
    ),
  );
});
mindbodySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mindbody = {
  category: 'brand',
  colorable: false,
  name: 'mindbody',
  svg: mindbodySvg,
};
